{
  "brand": {
    "title": "Registre SOR",
    "description": "Permettre une gestion transparente et efficace des crédits carbone pour un avenir durable."
  },
  "support": {
    "title": "Support",
    "help_center": "Centre d'Aide",
    "contact_support": "Contacter le Support",
    "submit_ticket": "Soumettre un Ticket",
    "system_status": "État du Système"
  },
  "legal": {
    "title": "Légal",
    "privacy_policy": "Politique de Confidentialité",
    "terms_of_service": "Conditions de Service",
    "cookie_policy": "Politique des Cookies",
    "disclaimer": "Avertissement"
  },
  "connect": {
    "title": "Connecter"
  },
  "copyright": "© Registre Sovereign Offset. Tous droits réservés."
}